import cx from 'classnames';

import { Icon, IconCallSolid } from '@flixbus/honeycomb-icons-react';
import { Box, Divider, Heading, Link, Text } from '@flixbus/honeycomb-react';

import { crewMemberInfoText } from '../text';

import styles from './styles.module.css';

const Essentials = ({
	employeeInfo,
	error,
	hasPermanentLocation,
	onOpenLocationsLog,
	onOpenSetHomeLocation,
	onOpenUpdateCrewLocation,
}) => {
	if (!employeeInfo || error) return null;

	const { homeLocation, currentLocation, arrivalTimeToCurrentLocation, phone } = employeeInfo;

	return (
		<Box extraClasses={styles.block}>
			<div className={styles.blockItem}>
				<div className={styles.blockRow}>
					<div>
						<Heading size={3} sectionHeader>
							{crewMemberInfoText.driverDomicile}
						</Heading>
						<div>{homeLocation}</div>
					</div>
					<div>
						<Heading size={3} sectionHeader>
							{crewMemberInfoText.phone}
						</Heading>
						<div>
							<Icon
								InlineIcon={IconCallSolid}
								appearance="secondary"
								extraClasses={styles.icon_phone_border}
							/>
							{phone}
						</div>
					</div>
				</div>

				<div className={cx(styles.blockRow, styles.start)}>
					<Link
						extraClasses={styles.link}
						onClick={() => onOpenSetHomeLocation(hasPermanentLocation)}
					>
						{crewMemberInfoText.changeHomeDomicile}
					</Link>

					<Link extraClasses={styles.link} onClick={onOpenLocationsLog}>
						{crewMemberInfoText.viewLog}
					</Link>
				</div>
			</div>

			<Divider />

			<div className={styles.blockRow}>
				<div className={styles.fullwidth}>
					<Heading size={3} sectionHeader>
						{crewMemberInfoText.currentLocation}
					</Heading>

					<div className={styles.arrivedLocation}>
						<div className={styles.locationWrapper}>
							<div className={styles.locationText}>{currentLocation}</div>
							<Link extraClasses={styles.confirmLocationLink} onClick={onOpenUpdateCrewLocation}>
								{crewMemberInfoText.moveToLocation}
							</Link>
						</div>
						{arrivalTimeToCurrentLocation !== null && (
							<Text small>{arrivalTimeToCurrentLocation}</Text>
						)}
					</div>
				</div>
			</div>
		</Box>
	);
};

export default Essentials;
